import { api, buildQueryString } from '@/api';
import { TemplateType } from './types';

/**
 * Fetches a short-lived SAS download link for the empty (un-populated) template
 * document. `GET template/download-empty` taking `template_type` + `template_id`,
 * returning a `downloadPath` + `downloadToken` the client hands to the Azure
 * uploader's `downloadFile` (matching the download flow used elsewhere in the
 * app).
 */
export interface TemplateDownloadEmptyProps {
  templateType: TemplateType;
  templateId: string;
}

export interface TemplateDownloadEmptyResponse {
  downloadPath: string;
  downloadToken: string;
}

const templateDownloadEmptyApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTemplateDownloadEmpty: builder.query<TemplateDownloadEmptyResponse, TemplateDownloadEmptyProps>({
      query: ({ templateType, templateId }: TemplateDownloadEmptyProps) => {
        const queryString = buildQueryString(
          { templateType, templateId },
          { templateType: 'template_type', templateId: 'template_id' },
        );
        return {
          url: `template/download-empty?${queryString}`,
          method: 'GET',
        };
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetTemplateDownloadEmptyQuery } = templateDownloadEmptyApi;
